// extracted by mini-css-extract-plugin
export var orderDetails = "_us-2";
export var orderImage = "_us-1";
export var orderMeta = "_us-3";
export var orderSummary = "_us-0";
export var rightArrow = "_us-4";